import { useState } from 'react';
import './informationDataValidationSupport.css';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import RadioGroup from '@mui/material/RadioGroup';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Switch from "react-switch";
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { supportFilterData,InformationDataValidationSupportProps,dummyData } from './informationDataValidationSupportType';
import { ChannelkartNetworkGet } from '../services/networkService';
import RenderSvg from '../components/renderSvg/RenderSvg';
import BackButton from '../components/Buttons/BackButton/BackButton';
import DefaultHeading from '../components/heading/DefaultHeading';
import { TranslationEnum, usePortalTranslation } from '../providers/TranslationProvider';

const InformationDataValidationSupport = (props:InformationDataValidationSupportProps) =>{
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "ValidationSupport";
    const CUR_COMPONENT_COMMON="commonPortal";
    const [filterData, setFilterData] = useState<any>(supportFilterData);
    const [openPopUp, setOpenPopUp] = useState<boolean>(false);
    const [checkBox, setCheckBox] = useState<boolean>(true);
    const [checked, setChecked] = useState<boolean>(true);
    const [validationData, setValidationData] = useState(dummyData);
    const [rows,setRows] = useState(validationData);
    const [anchor, setAnchor] = useState(null);
    
    const apiData = async () => {
      const url = getUrl();
      const apiData = await ChannelkartNetworkGet(url);
      const data = apiData?.data?.features?.map((metaDta:any)=>{
        return metaDta
      })
      if(data.length !== 0){
        setValidationData(data);
        setRows(data);
      }
    }

    const openPopOver = (event:any) => {
      setAnchor(event.currentTarget)
    }

    function copyBtnClickDataValidation(event:any){
      navigator.clipboard.writeText(JSON.stringify(validationData)); 
      setOpenPopUp(!openPopUp); 
      openPopOver(event)
    }

    function getUrl(){
      let api = props?.api;
      const dataLength = Object.keys(filterData)?.length;
      const lastElement = Object.keys(filterData)[dataLength-1];
      for(const key in filterData){
        if(filterData[key]){
          if(props?.filtersCheck?.check){
            api = api + key + props?.filtersCheck?.value + filterData[key];
            if(key !== lastElement && filterData[lastElement]){
              api = api + "&";
            }
          }
          else{
            api = props?.api + filterData[key];
          }
        }
      }
      return api;
    }

    const headers = validationData.length !== 0 ? Object.keys(validationData[0]): Object.keys(dummyData[0]);;
    
    const columns: GridColDef[] = [
    ];
    headers.forEach((obj, index) => {
      const col = {
        id : index,
        field: obj,
        headerName:translate(TranslationEnum.validation_support,obj),
        width: 150,
        editable: false,
        minWidth: 90
      }
      columns.push(col);
    })
    
    return (<>
        <div className='form-title-heading'>
          <DefaultHeading heading={translate(TranslationEnum.validation_support,props?.cardName)} showDefaultBackButton={true} />
        </div>
        <div className='form-input'>
            <div className='form-input-data'>
                <div className='form-input-description'>
                <p className='form-input-description-keyword'> {translate(TranslationEnum.common_portal,"Description")}: </p>
                <p className='form-input-description-detail'>{translate(TranslationEnum.validation_support,props?.description)}</p>
                </div>
                {props?.cardName === "PJPVisitPlan" && 
                <div className='form-input-checkbox'>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel control={<Radio onChange={ ()=> setCheckBox(true) }/>} checked={checkBox} label={translate(TranslationEnum.validation_support,"PJP Date")} />
                      <FormControlLabel control={<Radio onChange={ ()=> setCheckBox(false) }/>} checked={!checkBox} label={translate(TranslationEnum.validation_support,"Frequency")}/>
                    </RadioGroup>    
                  </FormControl>
                </div>}
                <div className='form-input-login'>
                    <TextField
                    required
                    id = "outlined-required"
                    label ={translate(TranslationEnum.validation_support,Object.keys(props?.filters)[0])}
                    placeholder={translate(TranslationEnum.validation_support,"Enter the User name")}
                    onChange={(event) =>{
                      if(event){
                        setFilterData((existingValues: any) => ({
                          ...existingValues,
                          loginId:event.target.value
                        }))
                      }
                    }
                    }
                    />
                </div>
                {props?.filters.Date !== undefined && 
                <div className='form-input-date'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label={translate(TranslationEnum.common_portal,"Date")}
                          inputFormat="DD-MM-YYYY"
                          value={filterData.date?filterData.date:dayjs()}
                          maxDate={dayjs()}
                          onChange={(event) => {
                            if(event){
                              const changeDateToString = event.toISOString().substring(0,10);
                              setFilterData((existingValues:any) => ({
                                ...existingValues,
                                date:changeDateToString
                              }))
                            }}
                            }
                          renderInput={(props) => (
                          <TextField {...props} disabled size="small" />
                          )}
                        />
                    </LocalizationProvider>
                </div>}
                <button className='form-input-button' onClick={apiData}> {translate(TranslationEnum.validation_support,"Load Data")} </button>
            </div>
            <p className='form-vertical-line'></p>
            <div className='form-output-data'>
                <div className='form-output-header'>
                    <div className='form-output-toggle-btn'>
                      <Switch
                        onChange={()=>setChecked(!checked)} 
                        checked = {checked}
                        offColor="#909090"
                        onColor="#24c6b1"
                        size={22}
                        handleDiameter={18}
                        uncheckedIcon={<>
                        <div className='unchecked-icon-status'>{translate(TranslationEnum.validation_support,"Table").toUpperCase()}</div>
                        </>}
                        checkedIcon={<>
                          <div className='checked-icon-status'>{translate(TranslationEnum.validation_support,"JSON").toUpperCase()}</div>
                        </>}
                        height={23}
                        width={60}
                      />
                    </div>
                    <div className='form-output-copy-btn' onClick={(event) => {copyBtnClickDataValidation(event); setTimeout(() => {setOpenPopUp(false);}, 2000);}}>
                      <RenderSvg name="dataValidationSupportCopyBtn" width="20%"/>
                        <Popover
                          id={"1"}
                          open={openPopUp}
                          elevation={50}
                          onClose={()=> setOpenPopUp(false)}
                          anchorEl={anchor}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal:0,
                          }}
                          transformOrigin={{
                            vertical:0,
                            horizontal:15
                          }}
                        >
                          <Typography sx={{ p: 1,
                          fontSize: "15px",
                          color: "#24c6b1"
                           }}>{translate(TranslationEnum.common_portal,"Copied")}</Typography>
                        </Popover>
                    </div>
                </div>
                {checked && 
                  <div className='form-output-json'>
                      <div className='form-output-json-data'>
                        <pre className = 'json-validate-data'>
                        {JSON.stringify(validationData, undefined, 2)}
                        </pre>
                      </div>
                  </div>
                }
                {!checked && 
                <div className='form-output-search-bar'>
                  <TextField
                  id="outlined-basic"
                  label={translate(TranslationEnum.common_portal,"Search")}
                  variant="outlined"
                  size="small"
                  fullWidth
                  autoComplete="off"
                  onChange={(e)=>{
                    const searchedData = e?.target?.value?.toString().toLowerCase();
                    const finalData = validationData.filter((eachRow:any)=>{
                      const allValues = Object.values(eachRow);
                      return allValues.find((eachValue:any)=>{
                        return eachValue?.toString().toLowerCase().includes(searchedData);
                      });
                    })
                    setRows(finalData);
                  }}
                />
                </div> }
                {!checked && 
                <div className='form-output-table'>
                  <Box sx={{ height: 400, width: '100%', overflow:'auto'}}>
                    <DataGrid
                      rows={rows}
                      columns={columns}
                      getRowId={(row: any) => row.id}
                      hideFooter={true}
                      autoHeight={true}
                    />
                  </Box>
                </div>
                }
            </div>
        </div>
        </>
    );
}

export default InformationDataValidationSupport;